export default function LocationSection() {
  return (
    <section className="py-24 bg-deep-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Map */}
          <div className="relative h-[500px] rounded-2xl overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3487.234567890123!2d-81.6851!3d28.8528!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e7a1234567890a%3A0x1234567890abcdef!2s1321%20S%20Bay%20St%2C%20Eustis%2C%20FL%2032726!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'grayscale(20%) invert(90%) contrast(90%)' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="High Standards Smoke Shop Location"
            ></iframe>
          </div>

          {/* Info Panel */}
          <div className="bg-forest-green rounded-2xl p-10 lg:p-12 flex flex-col justify-center">
            <h2 className="font-serif text-4xl lg:text-5xl text-white mb-8">
              Visit Us Today
            </h2>

            <div className="space-y-6">
              {/* Address */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-copper/10 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-copper text-xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">Address</h3>
                  <p className="text-gray-300">
                    1321 S Bay St<br />
                    Eustis, FL 32726, USA
                  </p>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-copper/10 rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-copper text-xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">Phone</h3>
                  <a
                    href="tel:+13529774832"
                    className="text-gray-300 hover:text-copper transition-colors duration-200 cursor-pointer"
                  >
                    +1 352 977-4832
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-copper/10 rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-copper text-xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">Email</h3>
                  <a
                    href="mailto:Highstandards.smokes@gmail.com"
                    className="text-gray-300 hover:text-copper transition-colors duration-200 cursor-pointer"
                  >
                    Highstandards.smokes@gmail.com
                  </a>
                </div>
              </div>

              {/* Hours */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-copper/10 rounded-full flex-shrink-0">
                  <i className="ri-time-line text-copper text-xl"></i>
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-2">Business Hours</h3>
                  <ul className="space-y-1 text-gray-300">
                    <li className="flex items-center gap-2">
                      <span className="w-2 h-2 bg-copper rounded-full"></span>
                      Monday - Thursday: 8am-10pm
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-2 h-2 bg-copper rounded-full"></span>
                      Friday - Saturday: 8am-11pm
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-2 h-2 bg-copper rounded-full"></span>
                      Sunday: 9am-10pm
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=1321+S+Bay+St,+Eustis,+FL+32726"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 px-8 py-4 bg-copper text-deep-black font-semibold rounded-full hover:bg-copper/90 transition-all duration-300 text-center whitespace-nowrap cursor-pointer inline-block"
            >
              Get Directions
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
